// @flow
import React from 'react';

import Config from './Config';
import Notification from './Notification';
import AuthWrapper from "./AuthWrapper";


class ConfigPage extends React.Component {
	render() {
		return (
			<div id="config_content">
				<Notification />
				<AuthWrapper role="admin">
					<Config />
				</AuthWrapper>
			</div>
		);
	}
}

export default ConfigPage;
